<div class="login-page">
  <div class="login-card" role="main">
    <div class="login-brand">
      <img src="/icon.svg" alt="" class="login-icon" />
      <span class="login-eyebrow">Admin console</span>
      <h1>Sign in to Skip To My Loo</h1>
      <p class="login-sub">Use your administrator account to manage the community.</p>
    </div>

    @if (!showForgotPassword) {
      <form class="login-form" (ngSubmit)="login()" #loginForm="ngForm" novalidate>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" [(ngModel)]="email" name="email" required [disabled]="loading"
            autocomplete="email" autocapitalize="off" spellcheck="false" />
          <mat-icon matPrefix>mail</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password" name="password" required
            [disabled]="loading" autocomplete="current-password" />
          <mat-icon matPrefix>lock</mat-icon>
          <button type="button" matSuffix class="eye-btn" (click)="hidePassword = !hidePassword" [disabled]="loading"
            [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'">
            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>

        @if (error) {
          <div class="login-callout is-error" role="alert">
            <mat-icon>error_outline</mat-icon>
            <span>{{ error }}</span>
          </div>
        }

        <button type="submit" class="login-btn" [disabled]="loading || !loginForm.valid" [class.is-loading]="loading">
          @if (loading) {
            <mat-spinner diameter="20"></mat-spinner>
            <span>Signing in</span>
          } @else {
            <span>Sign in</span>
          }
        </button>

        <button type="button" class="login-link" (click)="toggleForgotPassword()" [disabled]="loading">
          Forgot your password?
        </button>
      </form>
    } @else {
      <form class="login-form" (ngSubmit)="sendForgotPassword()" novalidate>
        <p class="login-hint">Enter your email and we will send you a link to reset your password.</p>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" [(ngModel)]="forgotEmail" name="forgotEmail" [disabled]="forgotLoading"
            autocomplete="email" autocapitalize="off" spellcheck="false" />
          <mat-icon matPrefix>mail</mat-icon>
        </mat-form-field>

        @if (forgotError) {
          <div class="login-callout is-error" role="alert">
            <mat-icon>error_outline</mat-icon>
            <span>{{ forgotError }}</span>
          </div>
        }

        @if (forgotMessage) {
          <div class="login-callout is-success" role="status">
            <mat-icon>check_circle</mat-icon>
            <span>{{ forgotMessage }}</span>
          </div>
        }

        <button type="submit" class="login-btn" [disabled]="forgotLoading" [class.is-loading]="forgotLoading">
          @if (forgotLoading) {
            <mat-spinner diameter="20"></mat-spinner>
            <span>Sending</span>
          } @else {
            <span>Send reset link</span>
          }
        </button>

        <button type="button" class="login-link" (click)="toggleForgotPassword()" [disabled]="forgotLoading">
          Back to sign in
        </button>
      </form>
    }
  </div>
</div>
